import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './share.module';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AuthService } from './services/auth.service';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import yaml from 'highlight.js/lib/languages/yaml';
import { ToastsModule } from './components/toasts/toasts.module';
import { ServerErrorInterceptor } from './interceptors/server-error.interceptor';
import { ConfigService } from './services/config.service';
import { initializeConfigService } from './initializeConfigService';

export function hljsLanguages() {
  return [{ name: 'yaml', func: yaml }];
}

registerLocaleData(localeEs);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    NgbModule,
    ToastsModule,
  ],
  providers: [
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        languages: hljsLanguages,
      },
    },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeConfigService,
      deps: [HttpClient, ConfigService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
